import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  Dropdown,
  Image,
  Nav,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ItemsInCart from "../components/cartItems";
import CheckoutSteps from "../components/CheckoutSteps";
import {
  addToCart,
  removeFromCart,
  updateShippingMethod,
} from "../actions/cartActions";
import SummaryRightBar from "../components/SummaryRightBar";
import Message from "../components/Message";
import axios from "axios";

const DeliveryScreen = ({ match, location, history }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // const productId = match.params.id;
  const query = new URLSearchParams(window.location.search);
  const referralId = query.get("referralId");
  const productId = query.get("product_id");
  const userLogin = useSelector((state) => state.userLogin);
  const [shipCart, setShipCart] = useState([]);
  const { userInfo } = userLogin;
  let qty;
  if (!!referralId) {
    qty = 1;
  } else {
    qty = location.search ? Number(location.search.split("=")[1]) : 1;
  }

  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(() => false);
  const [err, setErr] = useState(() => false);
  const [cartItems, setCartItems] = useState([]);
  const cart = useSelector((state) => state.cart);
  const { shippingCharge } = cart;
  useEffect(() => {
    if (productId) {
      dispatch(addToCart(productId, !!referralId && referralId, qty));
    }
  }, [dispatch, productId, qty]);

  useEffect(() => {
    if (!referralId) {
      let count = 0;
      for (let i = 0; i < cartItems.length; ++i) {
        if (cartItems[i].shipping_Obj) {
          if (cartItems[i].shipping_Obj.trim() != "") {
            ++count;
          }
        }
      }
      if (count == cartItems.length) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    }
  }, [cartItems]);

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!!disabled) {
      setErr(true);
      window.scrollTo(0, 0);
      setTimeout(() => {
        setErr(false);
      }, 4000);
    } else {
      if (referralId && productId) {
        history.push(
          `/payment?product_id=${productId}&referralId=${referralId}`
        );
      } else {
        history.push("/payment");
      }
    }

    // history.push("/payment");
  };

  useEffect(() => {
    (async () => {
      if (referralId && productId && userInfo?.token) {
        let config = {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
          params: {
            productId: productId,
            _id: userInfo._id,
          },
        };
        let response = await axios.get(`/api/cart/cart-by-product-id`, config);
        setShipCart(response.data);
        setCartItems(response?.data);
      }
      if (!referralId && !productId) {
        setCartItems(cart?.cartItems);
      }
    })();
  }, [referralId, productId, userInfo?.token, cart.cartItems]);

  // const shippingMethod = (id) => {
  //   dispatch(
  //     updateShippingMethod(
  //       "674449be70abb75a5ddc1c47",
  //       "674449be70abb75a5ddc1c47"
  //     )
  //   );
  // };

  return (
    <>
      <section className="checkout-sec section-padding nvS-deliveryScreen">
        <Container>
          <div className="inner-sec full-size">
            <div className="heading">
              <h3>checkout</h3>
            </div>
            <div className="main-sec full-size">
              <CheckoutSteps step1 step2 step3 />

              <Row>
                <Col md={12} lg={8} xl={8} className="order-2 order-lg-1">
                  <div className="shipping-methods">
                    <h4>Delivery</h4>
                    <Row>
                      <Col>
                        {err && (
                          <Message variant="danger">
                            Please Select a shipping method
                          </Message>
                        )}
                      </Col>
                    </Row>

                    <ItemsInCart cartItems={cartItems} shipping={true} />
                    <Form onSubmit={submitHandler}>
                      <div className="form full-size">
                        <div className="full">
                          <div className="button">
                            <LinkContainer to="/shipping" className="previous">
                              <Nav.Link>Previous</Nav.Link>
                            </LinkContainer>
                            <Button
                              disabled={shippingCharge === 0}
                              type="submit"
                              variant="primary next"
                            >
                              Continue
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </Col>

                <Col md={12} lg={4} xl={4} className="order-1 order-lg-2">
                  <SummaryRightBar cartItems={cartItems} />
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default DeliveryScreen;
